import {Action} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';

export const SET_HTTP_ERROR = 'SET_HTTP_ERROR';

export class SetHttpError implements Action {
  readonly type = SET_HTTP_ERROR;
  
  constructor(
    public payload: HttpErrorResponse
  ){}
}

export type ErrorActions = SetHttpError;